@if (team) { 
    <ion-avatar slot="start">
        <app-team-profile-image [team]="team" [tie]="tie" [pageName]="'teamLogo'"></app-team-profile-image>
    </ion-avatar>
} @else { 
    @if (showInviteSelect(sideNumber)) {
        <app-invite-team-owner
          [sideNumber]="sideNumber"
          [tie]="tie"
          (updateTie)="tie = $event"
        ></app-invite-team-owner>
        <app-select-tie-team
          [sideNumber]="sideNumber"
          [tie]="tie"
          (updateTie)="tie = $event"
        ></app-select-tie-team>
    } 
}
